<template>
  <dialog
    id="sheet-modal"
    class="sheet-modal"
    ref="sheetModal"
    v-if="isOpen"
    @close="closeModal"
  >
    <div class="sheet-modal__header">
      <button class="sheet-modal__exit-button" @click="closeModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5 8.25 12l7.5-7.5"
          />
        </svg>
        Exit
      </button>
      <div
        class="sheet-modal__title"
        :class="totalQuantity < item.metaData.maxItems && 'sheet-modal__title--warning'"
      >
        {{
          totalQuantity < item.metaData.maxItems
            ? `Fill your sheet ${totalQuantity}/${item.metaData.maxItems}`
            : 'Edit Sheet'
        }}
      </div>
    </div>
    <div class="sheet-modal__content">
      <button
        type="button"
        class="button button--secondary"
        v-if="item.metaData.url && totalQuantity < item.metaData.maxItems"
        @click="addDesign"
      >
        Add another design to this sheet
      </button>
      <p
        class="sheet-modal__topper-success"
        v-else-if="totalQuantity >= item.metaData.maxItems"
      >
        Nice, you've filled your sheet!
      </p>
      <ul class="sheet-modal__items">
        <li class="sheet-modal__item" v-for="design in designs">
          <img :src="design.thumbnail" alt="" />
          <div class="sheet-modal__item-inner">
            <div class="row">
              <button
                class="sheet-modal__edit"
                @click="editDesign(design)"
              >
                Edit
              </button>
              <button
                class="close-button"
                aria-label="Remove design"
                v-if="designs.length > 1"
                @click="removeDesign(design)"
              ></button>
            </div>
            <Quantity
              :value="design.quantity"
              :max="design.maxQuantity"
              @change="(quantity) => design.quantity = quantity"
            />
            <button
              class="sheet-modal__fill"
              v-if="totalQuantity < item.metaData.maxItems"
              @click="design.quantity = design.maxQuantity"
            >
              Fill Sheet
            </button>
          </div>
        </li>
      </ul>
    </div>
    <div class="sheet-modal__footer">
      <p class="sheet-modal__price">
        {{ item.price }}
      </p>
      <button
        class="button sheet-modal__button"
        :class="totalQuantity > 0 ? 'button--primary' : 'button--disabled'"
        :disabled="totalQuantity === 0"
        @click="updateSheet"
      >
        Update Sheet
      </button>
    </div>
  </dialog>
</template>

<script>
import Quantity from './Quantity.vue';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object
    }
  },
  data() {
    return {
      designs: []
    };
  },
  computed: {
    totalQuantity() {
      return this.designs.reduce((quantity, design) => {
        return quantity + design.quantity;
      }, 0);
    }
  },
  watch: {
    isOpen(value) {
      this.$nextTick(() => {
        if (value && this.$refs.sheetModal) {
          this.$refs.sheetModal.showModal();
          this.designs = JSON.parse(JSON.stringify(this.item.designs));
        }
      });
    },
    designs: {
      handler(value) {
        value.forEach((design) => {
          design.maxQuantity = this.item.metaData.maxItems - value.reduce((quantity, design) => quantity + design.quantity, 0) + design.quantity;
        });
      },
      deep: true
    }
  },
  methods: {
    addDesign() {
      this.performUpdate(() => {
        window.location.href = this.item.metaData.url + '?itemId=' + this.item.id;
      });
    },
    editDesign(design) {
      this.performUpdate(() => {
        this.$emit('edit', design);
      });
    },
    removeDesign(design) {
      this.$delete(this.designs, this.designs.indexOf(design));
    },
    updateSheet() {
      this.performUpdate(() => {
        this.closeModal();
      });
    },
    performUpdate(callback) {
      // update designs
      const sheet = { ...this.item, designs: this.designs };
      // update cart
      this.$emit('update', sheet, callback);
    },
    closeModal() {
      this.$emit('close');
    }
  },
  components: {
    Quantity
  }
};
</script>